import React, { useState } from 'react';
import EventBuilderModal from '../../EventBuilderModal/components/EventBuilderModal';

const icons = {
  arrowLeft: (
    <svg style={{width:20,height:20,minWidth:20,minHeight:20}} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 12H5M5 12L12 19M5 12L12 5" />
    </svg>
  ),
  edit01: (
    <svg style={{width:20,height:20,minWidth:20,minHeight:20}} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2.5 21.5L8.04927 19.3657C8.40421 19.2206 8.58168 19.148 8.74772 19.0561C8.8952 18.9741 9.03561 18.8803 9.16742 18.7758C9.31512 18.6582 9.44883 18.5245 9.71626 18.257L21 7C22.1046 5.89543 22.1046 4.10457 21 3C19.8954 1.89543 18.1046 1.89543 17 3L5.71626 14.2837C5.44883 14.5512 5.31512 14.6849 5.19745 14.8326C5.09297 14.9644 4.99916 15.1048 4.91714 15.2523C4.82518 15.4183 4.75256 15.5958 4.60731 15.9507L2.5 21.5ZM2.5 21.5L4.53349 16.1295C4.68934 15.7471 4.76726 15.5559 4.89503 15.4693C5.00724 15.3934 5.14296 15.3626 5.27577 15.3829C5.42738 15.406 5.57267 15.5513 5.86325 15.8419L8.15817 18.1367C8.44875 18.4273 8.59403 18.5726 8.61711 18.7242C8.63742 18.857 8.60661 18.9928 8.53074 19.105C8.44413 19.2327 8.25293 19.3107 7.87054 19.4665L2.5 21.5Z" />
    </svg>
  ),
  list: (
    <svg style={{width:20,height:20,minWidth:20,minHeight:20}} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12L9 12M21 6L9 6M21 18L9 18M5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12ZM5 6C5 6.55228 4.55228 7 4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5C4.55228 5 5 5.44772 5 6ZM5 18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18C3 17.4477 3.44772 17 4 17C4.55228 17 5 17.4477 5 18Z" />
    </svg>
  ),
  refreshCw: (
    <svg style={{width:20,height:20,minWidth:20,minHeight:20}} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10C21 10 18.995 7.26822 17.3662 5.63824C15.7373 4.00827 13.4864 3 11 3C6.02944 3 2 7.02944 2 12C2 16.9706 6.02944 21 11 21C15.1031 21 18.5649 18.2543 19.6482 14.5M21 10V4M21 10H15" />
    </svg>
  ),
  code01: (
    <svg style={{width:20,height:20,minWidth:20,minHeight:20}} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 18L22 12L16 6M8 6L2 12L8 18" />
    </svg>
  ),
  checkSquare: (
    <svg style={{width:20,height:20,minWidth:20,minHeight:20}} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 11L12 14L22 4M16 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V12" />
    </svg>
  ),
  barChart: (
    <svg style={{width:20,height:20,minWidth:20,minHeight:20}} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V12M8 13V17M16 11V17M12 7V17M2 5L5 2M5 2L8 5M5 2L5 8" />
    </svg>
  ),
  share07: (
    <svg style={{width:20,height:20,minWidth:20,minHeight:20}} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8.59 13.51L15.42 17.49M15.41 6.51L8.59 10.49M21 5C21 6.65685 19.6569 8 18 8C16.3431 8 15 6.65685 15 5C15 3.34315 16.3431 2 18 2C19.6569 2 21 3.34315 21 5ZM9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12ZM21 19C21 20.6569 19.6569 22 18 22C16.3431 22 15 20.6569 15 19C15 17.3431 16.3431 16 18 16C19.6569 16 21 17.3431 21 19Z" />
    </svg>
  ),
  users01: (
    <svg style={{width:20,height:20,minWidth:20,minHeight:20}} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z" />
    </svg>
  ),
  ticket01: (
    <svg style={{width:20,height:20,minWidth:20,minHeight:20}} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 8V7M10 12.5V11.5M10 17V16M5.2 4H18.8C19.9201 4 20.4802 4 20.908 4.21799C21.2843 4.40973 21.5903 4.71569 21.782 5.09202C22 5.51984 22 6.0799 22 7.2V8.5C20.067 8.5 18.5 10.067 18.5 12C18.5 13.933 20.067 15.5 22 15.5V16.8C22 17.9201 22 18.4802 21.782 18.908C21.5903 19.2843 21.2843 19.5903 20.908 19.782C20.4802 20 19.9201 20 18.8 20H5.2C4.0799 20 3.51984 20 3.09202 19.782C2.71569 19.5903 2.40973 19.2843 2.21799 18.908C2 18.4802 2 17.9201 2 16.8V15.5C3.933 15.5 5.5 13.933 5.5 12C5.5 10.067 3.933 8.5 2 8.5V7.2C2 6.0799 2 5.51984 2.21799 5.09202C2.40973 4.71569 2.71569 4.40973 3.09202 4.21799C3.51984 4 4.0799 4 5.2 4Z" />
    </svg>
  ),
  videoRecorder: (
    <svg style={{width:20,height:20,minWidth:20,minHeight:20}} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 8.93137C22 8.32555 22 8.02265 21.8802 7.88238C21.7763 7.76068 21.6203 7.69609 21.4608 7.70865C21.2769 7.72312 21.0627 7.93731 20.6343 8.36569L17 12L20.6343 15.6343C21.0627 16.0627 21.2769 16.2769 21.4608 16.2914C21.6203 16.3039 21.7763 16.2393 21.8802 16.1176C22 15.9774 22 15.6744 22 15.0686V8.93137ZM2 9.8C2 8.11984 2 7.27976 2.32698 6.63803C2.6146 6.07354 3.07354 5.6146 3.63803 5.32698C4.27976 5 5.11984 5 6.8 5H11.2C12.8802 5 13.7202 5 14.362 5.32698C14.9265 5.6146 15.3854 6.07354 15.673 6.63803C16 7.27976 16 8.11984 16 9.8V14.2C16 15.8802 16 16.7202 15.673 17.362C15.3854 17.9265 14.9265 18.3854 14.362 18.673C13.7202 19 12.8802 19 11.2 19H6.8C5.11984 19 4.27976 19 3.63803 18.673C3.07354 18.3854 2.6146 17.9265 2.32698 17.362C2 16.7202 2 15.8802 2 14.2V9.8Z" />
    </svg>
  ),
};

const getCards = (team) => {
  const basePath = `/teams/${team.id}/giving/new`;

  return [
    {
      title: 'Form',
      description: 'The simplest solution for receiving donations.',
      features: [
        { icon: icons.edit01, label: 'Custom Branding' },
        { icon: icons.list, label: 'Form Elements' },
        { icon: icons.refreshCw, label: 'Recurring Donations' },
        { icon: icons.code01, label: 'Embeddable Widget' },
      ],
      buttonLabel: 'Start a Form',
      href: `${basePath}?campaign_format=form`,
      enabled: true,
    },
    {
      title: 'Page',
      description: 'Crowdfunding around a set goal or story.',
      features: [
        { icon: icons.checkSquare, label: 'All Features of Forms', bold: true },
        { icon: icons.barChart, label: 'Progress Tracking' },
        { icon: icons.share07, label: 'Social Sharing' },
        { icon: icons.users01, label: 'Supporter Feed' },
      ],
      buttonLabel: 'Start a Page',
      href: `${basePath}?campaign_format=page`,
      enabled: true,
    },
    {
      title: 'Event',
      description: 'For ticketed in-person, virtual, or hybrid fundraisers.',
      features: [
        { icon: icons.checkSquare, label: 'All Features of Pages', bold: true },
        { icon: icons.ticket01, label: 'Tickets & Items' },
        { icon: icons.videoRecorder, label: 'Live Streaming' },
      ],
      buttonLabel: 'Start an Event',
      action: 'event',
      enabled: true,
    },
  ];
};

const GivingCampaignTypeSelector = ({ team, event_builder }) => {
  const cards = getCards(team);
  const [eventModalOpen, setEventModalOpen] = useState(false);

  return (
    <div className="gcts">
      <style>{`
        .gcts {
          --sl-text-primary: #181D27;
          --sl-text-secondary: #414651;
          --sl-text-tertiary: #535862;
          --sl-text-quaternary: #717680;
          --sl-bg-primary: #FFFFFF;
          --sl-bg-secondary: #FAFAFA;
          --sl-bg-tertiary: #F5F5F5;
          --sl-border-primary: #D5D7DA;
          --sl-border-secondary: #E9EAEB;
          --sl-brand-600: #1982C4;
          --sl-shadow-xs: 0 1px 2px 0 rgba(10, 13, 18, 0.05);
          --sl-radius-md: 8px;
          --sl-radius-xl: 12px;

          min-height: 100vh;
          font-family: 'Open Sans', sans-serif;
        }
        html[data-theme="dark"] body.od-themed .gcts {
          --sl-text-primary: #F5F6F8;
          --sl-text-secondary: #CDD2DC;
          --sl-text-tertiary: #A4ABB8;
          --sl-text-quaternary: #8B92A0;
          --sl-bg-primary: #161B26;
          --sl-bg-secondary: #1C222E;
          --sl-bg-tertiary: #22293A;
          --sl-border-primary: #333B4A;
          --sl-border-secondary: #283040;
        }
        .gcts-inner { padding: 16px; }
        .gcts-header { margin-bottom: 16px; }
        .gcts-back {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          color: var(--sl-text-tertiary);
          font-size: 14px;
          line-height: 20px;
          font-weight: 600;
          text-decoration: none;
        }
        .gcts-back:hover { color: var(--sl-text-secondary); text-decoration: none; }
        .gcts-title {
          font-size: 20px;
          line-height: 30px;
          font-weight: 700;
          margin: 12px 0 4px 0;
          color: var(--sl-text-primary);
        }
        .gcts-subtitle {
          font-size: 14px;
          line-height: 20px;
          color: var(--sl-text-tertiary);
          margin: 0;
        }
        .gcts-card-container {
          background: var(--sl-bg-primary);
          border-radius: var(--sl-radius-xl);
          padding: 32px;
          border: 1px solid var(--sl-border-secondary);
          box-shadow: var(--sl-shadow-xs);
        }
        .gcts-type-card {
          background: var(--sl-bg-primary);
          border-radius: var(--sl-radius-xl);
          border: 1px solid var(--sl-border-secondary);
          padding: 24px;
          display: flex;
          flex-direction: column;
          height: 100%;
          transition: box-shadow 0.2s, border-color 0.2s;
        }
        .gcts-type-card--enabled:hover {
          box-shadow: 0 4px 6px -2px rgba(10,13,18,0.03), 0 12px 16px -4px rgba(10,13,18,0.08);
          border-color: var(--sl-brand-600);
        }
        .gcts-type-card--disabled { opacity: 0.6; cursor: default; }
        .gcts-card-title {
          font-size: 24px;
          line-height: 32px;
          font-weight: 700;
          margin: 0 0 4px 0;
          color: var(--sl-text-primary);
        }
        .gcts-card-desc {
          font-size: 14px;
          line-height: 20px;
          color: var(--sl-text-tertiary);
          margin: 0 0 20px 0;
        }
        .gcts-divider {
          border: none;
          border-top: 1px solid var(--sl-border-secondary);
          margin: 0 0 16px 0;
        }
        .gcts-feature {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 6px 0;
          font-size: 14px;
          line-height: 20px;
          color: var(--sl-text-primary);
        }
        .gcts-feature-icon { color: var(--sl-brand-600); line-height: 0; flex-shrink: 0; }
        .gcts-feature-icon svg { width: 20px; height: 20px; flex-shrink: 0; }
        .gcts-btn-action { margin-top: 24px; }
        .gcts-btn-secondary {
          display: block;
          width: 100%;
          text-align: center;
          padding: 8px 12px;
          border-radius: var(--sl-radius-md);
          border: 1px solid var(--sl-border-primary);
          background: var(--sl-bg-primary);
          color: var(--sl-text-secondary);
          font-family: 'Open Sans', sans-serif;
          font-weight: 600;
          font-size: 14px;
          line-height: 20px;
          text-decoration: none;
          cursor: pointer;
          box-shadow: 0 -2px 0 0 rgba(10,13,18,0.05) inset, var(--sl-shadow-xs);
          transition: background-color 0.2s;
        }
        .gcts-btn-secondary:hover { background: var(--sl-bg-secondary); text-decoration: none; }
        .gcts-btn-disabled {
          display: block;
          width: 100%;
          text-align: center;
          padding: 8px 12px;
          border-radius: var(--sl-radius-md);
          border: 1px solid var(--sl-border-primary);
          background: var(--sl-bg-tertiary);
          color: var(--sl-text-quaternary);
          font-family: 'Open Sans', sans-serif;
          font-weight: 600;
          font-size: 14px;
          line-height: 20px;
          cursor: default;
        }
      `}</style>

      <div className="gcts-inner">
        <div className="gcts-header">
          <a href={`/teams/${team.id}/giving`} className="gcts-back">
            {icons.arrowLeft}
            Back to Campaigns
          </a>
          <h2 className="gcts-title">Create a Campaign</h2>
          <p className="gcts-subtitle">Choose the type of campaign that best fits your fundraising needs.</p>
        </div>

        <div className="gcts-card-container">
          <div className="row">
            {cards.map((card) => (
              <div key={card.title} className="col-md-4 mb-3 mb-md-0">
                <div className={`gcts-type-card ${card.enabled ? 'gcts-type-card--enabled' : 'gcts-type-card--disabled'}`}>
                  <h3 className="gcts-card-title">{card.title}</h3>
                  <p className="gcts-card-desc">{card.description}</p>
                  <hr className="gcts-divider" />

                  <div style={{ flex: 1 }}>
                    {card.features.map((feature, i) => (
                      <div key={i} className="gcts-feature">
                        <span className="gcts-feature-icon">{feature.icon}</span>
                        <span style={{ fontWeight: feature.bold ? 600 : 400 }}>
                          {feature.label}
                        </span>
                      </div>
                    ))}
                  </div>

                  <div className="gcts-btn-action">
                    {!card.enabled ? (
                      <div className="gcts-btn-disabled">
                        Coming Soon
                      </div>
                    ) : card.action === 'event' ? (
                      <button type="button" className="gcts-btn-secondary" onClick={() => setEventModalOpen(true)}>
                        {card.buttonLabel}
                      </button>
                    ) : (
                      <a href={card.href} className="gcts-btn-secondary">
                        {card.buttonLabel}
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <EventBuilderModal
        isOpen={eventModalOpen}
        onClose={() => setEventModalOpen(false)}
        eventBuilder={event_builder}
      />
    </div>
  );
};

export default GivingCampaignTypeSelector;
